module.exports = __webpack_public_path__ + "img/2.1e4fda95.jpeg";